export const GET_DATA_MATCHES       = "GET_DATA_MATCHES"
export const SHOW_DATE_MATCHES_EM   = "SHOW_DATE_MATCHES_EM"
export const SHOW_DATE_MATCHES_CA   = "SHOW_DATE_MATCHES_CA"
export const GET_DATA_LAST_MATCHES  = "GET_DATA_LAST_MATCHES"
export const GET_DATA_NEXT_MATCHES_TEAM  = "GET_DATA_NEXT_MATCHES_TEAM"
export const DATA_PREDICTIONS_MATCHES  = "DATA_PREDICTIONS_MATCHES"
export const DATA_ALL_PREDICTIONS_MATCHES  = "DATA_ALL_PREDICTIONS_MATCHES"
export const DATA_SELECTIONS_MATCHES  = "DATA_SELECTIONS_MATCHES"
export const CURRENT_DATE_MATCH  = "CURRENT_DATE_MATCH"